import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Button, Col, Form, Row, Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Banderas from '../Banderas';
import TelefonosAdicionalesCliente from './TelefonosAdicionalesCliente';

const DetallesInformacionContacto = ({
    customerdetails,
    editar,
    register,
    errors,
    countries,
    states,
    cargandoEstado,
    documentos,
    documentosCargados,
    dataFiles,
    setDataFiles,
    setDocumentosCargados,
    onSubmitDocFile,
    cargandoFile,
    handlePaisChange,
    onTelefonoChange
}) => {
    return (
        <Col className="col-lg-6 col-12">
            <h5 className="fw-semi-bold ls mb-3 text-uppercase">
                <FontAwesomeIcon icon="phone" className="ms-2" /> INFORMACI&Oacute;N DE CONTACTO
            </h5>
            <Table responsive striped size="sm">
                <tbody>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Tipo Cliente</strong>
                        </td>
                        <td>
                            {editar ? (
                                <Form.Select
                                    size="sm"
                                    defaultValue={customerdetails.idCatTipoCliente}
                                    aria-label="Default select"
                                    {...register("idCatTipoCliente", {
                                        required: true
                                    })}
                                >
                                    <option value="1">CONSUMIDOR FINAL</option>
                                    <option value="2">DISTRIBUIDOR</option>
                                </Form.Select>
                            ) : (
                                customerdetails.vDescripcionTipo
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Tel&eacute;fono Personal</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        defaultValue={customerdetails.vTelefonoPersonal}
                                        isInvalid={!!errors.vTelefonoPersonal}
                                        {...register("vTelefonoPersonal", {
                                            required: 'Este campo es requerido, incluya el c\u00f3digo de pais: ejemplo: +52',
                                            maxLength: 20,
                                            minLength: 6,
                                            pattern: {
                                                value: /^[+][0-9]+$/,
                                                message: "Tel\u00E9fono incorrecto. Debe iniciar con el prefijo: +"
                                            }
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vTelefonoPersonal && errors.vTelefonoPersonal.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                <>
                                    <Row>
                                        <Col>
                                            <span>{customerdetails.vTelefonoPersonal} </span>
                                        </Col>
                                        <Col xs="auto">
                                            <a href={"https://wa.me/" + customerdetails.vTelefonoPersonal} target="_blank" rel="noreferrer">
                                                <img width="25" src="/img/whatsapp40.png" alt="WhatsApp" /> Enviar mensaje
                                            </a>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Tel&eacute;fono Trabajo</strong>
                        </td>
                        <td>
                            {editar ? (
                                <Form.Control
                                    size="sm"
                                    autoComplete="off"
                                    type="text"
                                    defaultValue={customerdetails.vTelefonoTrabajo}
                                    isInvalid={!!errors.vTelefonoTrabajo}
                                    {...register("vTelefonoTrabajo", {
                                        required: false,
                                        maxLength: 20,
                                        minLength: 5,
                                        pattern: {
                                            value: /^[+][0-9]+$/,
                                            message: "Tel\u00E9fono incorrecto. Debe iniciar con el prefijo: +"
                                        }
                                    })}
                                />
                            ) : (
                                customerdetails.vTelefonoTrabajo
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4" style={{ verticalAlign: 'top', paddingTop: '8px' }}>
                            <strong>Tel&eacute;fonos Adicionales</strong>
                        </td>
                        <td>
                            {customerdetails?.idClienteAkasia ? (
                                <TelefonosAdicionalesCliente
                                    idClienteAkasia={customerdetails.idClienteAkasia}
                                    paisCliente={customerdetails?.vPais}
                                    onTelefonoChange={onTelefonoChange}
                                />
                            ) : null}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Pa&iacute;s</strong>
                        </td>
                        <td>
                            {editar ? (
                                <Form.Select
                                    aria-label="Default select"
                                    size="sm"
                                    defaultValue={customerdetails.vPais}
                                    isInvalid={!!errors.vPais}
                                    {...register("vPais", {
                                        required: true
                                    })}
                                    onChange={handlePaisChange}
                                >
                                    {countries.map((country, index) => {
                                        return (
                                            <option key={index} value={country.vName}>
                                                {country.vName}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            ) : (
                                <>
                                    <Banderas Height={20} vPais={customerdetails.vPais} />
                                    {customerdetails.vPais}
                                </>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Estado/Provincia</strong>
                        </td>
                        <td>
                            {cargandoEstado ? (
                                <h5>
                                    <Spinner className="text-inline" size="sm" animation="border" variant="primary" /> Cargando...
                                </h5>
                            ) : editar ? (
                                <Form.Select
                                    size="sm"
                                    aria-label="Default select"
                                    defaultValue={customerdetails.vEstadoDepProv}
                                    isInvalid={!!errors.vEstadoDepProv}
                                    {...register("vEstadoDepProv", {
                                        required: true
                                    })}
                                >
                                    <option value="">Selecciona estado/provincia</option>
                                    {states.map((st, index) => {
                                        return (
                                            <option key={index} value={st.vName}>
                                                {st.vName}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            ) : (
                                <span>{customerdetails.vEstadoDepProv}</span>
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
            <hr />
            {customerdetails.idCatTipoCliente == 2 && (
                <>
                    <Alert variant="primary">
                        <h5>CLIENTE DISTRIBUIDOR</h5>
                    </Alert>
                    <Table responsive striped size="sm">
                        <tbody>
                            {documentos.map((doc, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <Link
                                                to={"/api/distribuidor/OnGetFile/?idClienteAkasia=" + customerdetails.idClienteAkasia + "&vNombreArchivo=" + doc.DocName}
                                                target="_blank"
                                            >
                                                <Flex
                                                    alignItems="center"
                                                    className="border px-2 rounded-3 bg-white dark__bg-1000 my-1 fs--1"
                                                >
                                                    <FontAwesomeIcon icon={'file'} className="fs-1" />
                                                    <span className="mx-2 flex-1">
                                                        {doc.DocName} ({(2000 / 1024).toFixed(2)}kb)
                                                    </span>
                                                    <span className="text-300 p-1 ml-auto cursor-pointer">
                                                        <FontAwesomeIcon icon="download" />
                                                    </span>
                                                </Flex>
                                            </Link>
                                        </td>
                                    </tr>
                                )
                            })}

                            {documentosCargados.docIDFoto && (
                                <>
                                    <tr>
                                        <td colSpan={2}>
                                            <b>Identificaci&oacute;n con Foto</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Control
                                                type="file"
                                                size="sm"
                                                required
                                                onChange={(e) => {
                                                    setDataFiles({
                                                        ...dataFiles,
                                                        DocFile: e.target.files[0]
                                                    });
                                                    setDocumentosCargados(documentosCargados => {
                                                        return {
                                                            ...documentosCargados,
                                                            docCompDomicilio: false,
                                                            docCartaMotivos: false,
                                                            docCedFiscal: false
                                                        }
                                                    })
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {cargandoFile ? (
                                                <Button size="sm" variant="primary" disabled>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    ...
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    type="button"
                                                    onClick={() => onSubmitDocFile(1)}
                                                    variant='primary'
                                                >
                                                    Subir
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                </>
                            )}

                            {documentosCargados.docCedFiscal && (
                                <>
                                    <tr>
                                        <td colSpan={2}>
                                            <b>Documento Fiscal</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Control
                                                type="file"
                                                size="sm"
                                                required
                                                onChange={(e) => {
                                                    setDataFiles({
                                                        ...dataFiles,
                                                        DocFile: e.target.files[0]
                                                    });
                                                    setDocumentosCargados(documentosCargados => {
                                                        return {
                                                            ...documentosCargados,
                                                            docIDFoto: false,
                                                            docCompDomicilio: false,
                                                            docCartaMotivos: false
                                                        }
                                                    })
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {cargandoFile ? (
                                                <Button size="sm" variant="primary" disabled>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    ...
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    type="button"
                                                    onClick={() => onSubmitDocFile(2)}
                                                    variant='primary'
                                                >
                                                    Subir
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                </>
                            )}

                            {documentosCargados.docCompDomicilio && (
                                <>
                                    <tr>
                                        <td colSpan={2}>
                                            <b>Comprobante de Domicilio</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Control
                                                type="file"
                                                size="sm"
                                                required
                                                onChange={(e) => {
                                                    setDataFiles({
                                                        ...dataFiles,
                                                        DocFile: e.target.files[0]
                                                    });
                                                    setDocumentosCargados(documentosCargados => {
                                                        return {
                                                            ...documentosCargados,
                                                            docIDFoto: false,
                                                            docCedFiscal: false,
                                                            docCartaMotivos: false
                                                        }
                                                    })
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {cargandoFile ? (
                                                <Button size="sm" variant="primary" disabled>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    ...
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    type="button"
                                                    onClick={() => onSubmitDocFile(3)}
                                                    variant='primary'
                                                >
                                                    Subir
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                </>
                            )}

                            {documentosCargados.docCartaMotivos && (
                                <>
                                    <tr>
                                        <td colSpan={2}>
                                            <b>Carta de Motivos</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Control
                                                type="file"
                                                size="sm"
                                                required
                                                onChange={(e) => {
                                                    setDataFiles({
                                                        ...dataFiles,
                                                        DocFile: e.target.files[0]
                                                    });
                                                    setDocumentosCargados(documentosCargados => {
                                                        return {
                                                            ...documentosCargados,
                                                            docIDFoto: false,
                                                            docCedFiscal: false,
                                                            docCompDomicilio: false
                                                        }
                                                    })
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {cargandoFile ? (
                                                <Button size="sm" variant="primary" disabled>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    ...
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    type="button"
                                                    onClick={() => onSubmitDocFile(4)}
                                                    variant='primary'
                                                >
                                                    Subir
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </Table>
                </>
            )}
        </Col>
    );
};

DetallesInformacionContacto.propTypes = {
    customerdetails: PropTypes.shape({
        idClienteAkasia: PropTypes.number,
        idCatTipoCliente: PropTypes.number,
        vDescripcionTipo: PropTypes.string,
        vTelefonoPersonal: PropTypes.string,
        vTelefonoTrabajo: PropTypes.string,
        vPais: PropTypes.string,
        vEstadoDepProv: PropTypes.string
    }).isRequired,
    editar: PropTypes.bool.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    countries: PropTypes.arrayOf(
        PropTypes.shape({
            vName: PropTypes.string
        })
    ).isRequired,
    states: PropTypes.arrayOf(
        PropTypes.shape({
            vName: PropTypes.string
        })
    ).isRequired,
    cargandoEstado: PropTypes.bool.isRequired,
    documentos: PropTypes.arrayOf(
        PropTypes.shape({
            DocName: PropTypes.string
        })
    ).isRequired,
    documentosCargados: PropTypes.shape({
        docIDFoto: PropTypes.bool,
        docCedFiscal: PropTypes.bool,
        docCompDomicilio: PropTypes.bool,
        docCartaMotivos: PropTypes.bool
    }).isRequired,
    dataFiles: PropTypes.shape({
        DocFile: PropTypes.any
    }).isRequired,
    setDataFiles: PropTypes.func.isRequired,
    setDocumentosCargados: PropTypes.func.isRequired,
    onSubmitDocFile: PropTypes.func.isRequired,
    cargandoFile: PropTypes.bool.isRequired,
    handlePaisChange: PropTypes.func.isRequired,
    onTelefonoChange: PropTypes.func
};

export default DetallesInformacionContacto;